import { render, staticRenderFns } from "./procedimientos.vue?vue&type=template&id=2481b149"
import script from "./procedimientos.vue?vue&type=script&lang=js"
export * from "./procedimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports